import TargetUserSelector from "./TargetUserSelector";
import WorkspaceSelector from "./WorkspaceSelector";

import G from './Getters';
import A from './ActionCreators.js';
import { useStore, useDispatch } from 'react-redux';

export default function ViewAsUserDropdown(){

  const dispatch = useDispatch();

  const store = useStore();
  
  const state = store.getState();

  const currentWorkspace = G.getCurrentWorkspaceInfo(state);
  let { groupId, userId } = currentWorkspace;

  

    

  return (
    <>
    <div style={{
      borderTop:'1px solid #ccc',
    }} class="sg-row v-center">
      
      
        <WorkspaceSelector/>

      {groupId && <TargetUserSelector/>}
      
    </div>

    </>
  )
}
